/**
 * 2023-04-13 Current app usage TBD
 **/
export class SubscriberFilter {
  async resources() {
    const response = await fetch("/subscriber_filter/filterable_resources", {
      credentials: "include",
      headers: {
        Accept: "application/json"
      }
    })
    return await response.json()
  }
}
